var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('secition-card', _vm._b({
    attrs: {
      "title": "지원자"
    }
  }, 'secition-card', {
    loading: _vm.loading
  }, false), [_c('statistics-chart-applications', _vm._b({}, 'statistics-chart-applications', {
    statistics: _vm.statistics,
    statistics_visit: _vm.statistics_visit,
    searchDateValue: _vm.searchDateValue
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }